{
  "card": {
    "title": "Jobs from your ERP",
    "body": "Export open jobs from your ERP as CSV or Excel and Deburr creates an FAI for each new job and part number, with the PO, due date and quantity filled in. Drop the drawings in too and they are read straight away. Jobs that already have an FAI are skipped.",
    "erp": "ERP",
    "anyErp": "Any ERP (match columns by name)",
    "import": "Import jobs (CSV or Excel)",
    "noAccess": "Only inspectors and above can import jobs.",
    "preset": "Preset",
    "expected": "Expected columns: {{cols}}.",
    "readError": "Could not read that file."
  },
  "dialog": {
    "title": "Import jobs from {{file}}",
    "create_one": "Create {{count}} FAI",
    "create_other": "Create {{count}} FAIs",
    "notInFile": "Not in the file",
    "addDrawings": "Add drawings",
    "drawingsAdded_one": "{{count}} drawing added. Matched by the drawing column, or by part number.",
    "drawingsAdded_other": "{{count}} drawings added. Matched by the drawing column, or by part number.",
    "drawingsHint": "Optional. Each matched drawing is read with AI as the FAI is created.",
    "presetNote": "Columns were matched with the preset's guessed names. Check each one above against your file before importing.",
    "rowAria": "Import row {{row}}",
    "none": "none",
    "rev": " Rev {{rev}}",
    "existing": "{{label}} ({{faiNo}})"
  },
  "cols": {
    "import": "Import",
    "job": "Job",
    "part": "Part",
    "customer": "Customer",
    "qty": "Qty",
    "due": "Due",
    "po": "PO",
    "drawing": "Drawing",
    "status": "Status"
  },
  "running": {
    "creating_one": "Creating {{count}} FAI",
    "creating_other": "Creating {{count}} FAIs",
    "reading": "Reading drawing {{n}} of {{total}}: {{file}}"
  },
  "errors": {
    "noFaisLeft": "Your plan has no FAIs left this period.",
    "failed": "failed",
    "stopped": "The import stopped with an error."
  },
  "outcome": {
    "created_one": "Created {{count}} FAI",
    "created_other": "Created {{count}} FAIs",
    "withDrawing": ", {{n}} with the drawing read",
    "skipped": " Skipped {{n}} that already had an FAI.",
    "stopped": "Stopped: {{msg}}",
    "seePlans": "See plans",
    "findThem": "Find them under <0>Inspections</0>."
  },
  "status": {
    "new": "New",
    "exists": "Already an FAI",
    "duplicate": "Repeated in file",
    "invalid": "No part number"
  },
  "summary": {
    "new": "{{n}} new",
    "exists": "{{n}} already FAIs",
    "duplicate": "{{n}} repeated",
    "invalid": "{{n}} without a part number",
    "selected": "{{list}}. {{n}} selected.",
    "cap_one": " Your plan has room for {{count}} more FAI this period; the import stops there.",
    "cap_other": " Your plan has room for {{count}} more FAIs this period; the import stops there."
  }
}
